export default __webpack_public_path__ + "static/media/info-03.f595e1ef.png";